export type { ClientConfig } from './client-config';
export {
	CLIENT_CONFIG_MAP,
	DEFAULT_CLIENT_CONFIG,
	getClientConfig,
	IOC_CLIENT_CONFIG,
} from './client-config';
